import { render, staticRenderFns } from "./myVideo.vue?vue&type=template&id=5a0f3a34&scoped=true&"
import script from "./myVideo.vue?vue&type=script&lang=js&"
export * from "./myVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0f3a34",
  null
  
)

export default component.exports